import React, { useEffect, useState } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import {
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Nav,
  NavItem,
  Row,
  TabContent,
  TabPane,
  NavLink,
} from "reactstrap"
import { useNavigate } from "react-router-dom"
import SendNotification from "./SendNotification"
import NotificationHistory from "./NotificationHistory"
import ScheduleNotification from "./ScheduleNotification"
import isPermissionEnabled from "common/isPermissionEnabled"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

const PushNotification = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  const [activeTab, setActiveTab] = useState("1")
  const navigate = useNavigate()

  const { userRole, accountType } = useSelector(state => state.Login)

  const [usersPermissions, setUsersPermissions] = useState({
    list: null,
    edit: null,
  })

  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionList = isPermissionEnabled(
      userRole,
      15,
      "notification_1",
      accountType
    )
    const isPermissionEdit = isPermissionEnabled(
      userRole,
      15,
      "notification_3",
      accountType
    )

    if (!isPermissionList) {
      navigate("/dashboard")
    }
    setUsersPermissions({
      list: isPermissionList,
      edit: isPermissionEdit,
    })
  }, [userRole])

  const toggle = tab => {
    if (activeTab !== tab) {
      setActiveTab(tab)
      navigate("/push-notifications")
    }
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />
        <div className="row">
          <div className="col-12">
            <Card>
              <CardBody>
                <CardTitle>{t("Push Notifications")}</CardTitle>

                <Nav tabs className="mt-2">
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={`nav-link ${
                        activeTab === "1" ? "active" : ""
                      }`}
                      onClick={() => {
                        toggle("1")
                      }}
                    >
                      <span>{t("Send Notification")}</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={`nav-link ${
                        activeTab === "2" ? "active" : ""
                      }`}
                      onClick={() => {
                        toggle("2")
                      }}
                    >
                      <span>{t("Scheduled Notification")}</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={`nav-link ${
                        activeTab === "3" ? "active" : ""
                      }`}
                      onClick={() => {
                        toggle("3")
                      }}
                    >
                      <span>{t("History")}</span>
                    </NavLink>
                  </NavItem>
                </Nav>

                <TabContent activeTab={activeTab} className="p-3">
                  <TabPane tabId="1">
                    <SendNotification t={t} />
                  </TabPane>
                  <TabPane tabId="2">
                    <ScheduleNotification
                      activeTab={activeTab}
                      t={t}
                      language={language}
                    />
                  </TabPane>
                  <TabPane tabId="3">
                    <NotificationHistory
                      activeTab={activeTab}
                      t={t}
                      language={language}
                    />
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PushNotification
